import { css } from "@emotion/react";
import { responsiveBreakpoint } from "@constants";

export const rowCompanyName = css`
  margin-bottom: 32px;
`;

export const title = css`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  letter-spacing: -0.5px;
  color: var(--gray-600);
  margin-bottom: 10px;
`;

export const sub = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: -0.2px;
  color: var(--gray-500);
  word-break: keep-all;
`;

export const subDark = css`
  color: var(--gray-700);
`;

export const line = css`
  @media (max-width: ${responsiveBreakpoint[0]}px) {
    &::after {
      content: ", ";
      margin-right: 5px;
    }
  }
`;

export const button = css`
  button {
    padding: 0;
    width: 110px;
    height: 40px;
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.2px;
    color: var(--gray-700);
  }
`;
